// application.jsとは別bundleなので注意（application.js側で定義された変数や生成されたインスタンス等は共有されません）
import { Turbo } from "@hotwired/turbo-rails"
const { StreamActions } = Turbo

StreamActions.redirect = function(){
  const url = this.getAttribute('url') || '/';
  Turbo.visit(url, { frame: '_top', action: 'advance' });
}

StreamActions.scroll_to_top = function() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

StreamActions.payment_btn_activate = function() {
  const $paymentBtn = $("#reservation_paymentButton");

  if ($paymentBtn.length === 0) {
    return;
  }

  $paymentBtn.prop("disabled", false);
}

StreamActions.user_cancel_btn_activate = function() {
  const $cancelBtn = $("#cancel_reservationButton");

  if ($cancelBtn.length === 0) {
    return;
  }

  $cancelBtn.removeClass('disabled');
}

StreamActions.reservation_detail_show = function(){
  $(".stRoomRes_list").hide();
  $(".stRoomRes_detail").show();
}

StreamActions.reservation_list_show = function(){
  $(".stRoomRes_detail").hide();
  $(".stRoomRes_list").show();
}

StreamActions.initialize_reservation_calendar_data = function(){
  const data = this.getAttribute("data");
  // application.js側に処理を委譲するために、カスタムイベントを利用
  document.dispatchEvent(new CustomEvent("calendar:data-initialize", { detail: { data } }));
}

StreamActions.update_reservation_calendar_data = function(){
  const data = this.getAttribute("data");
  // application.js側に処理を委譲するために、カスタムイベントを利用
  document.dispatchEvent(new CustomEvent("calendar:data-update", { detail: { data } }));
}

StreamActions.calendar_update_end = function(){
  // application.js側に処理を委譲するために、カスタムイベントを利用
  document.dispatchEvent(new CustomEvent("calendar:update-end"));
}

// application.js側からTurboを使ってページ遷移したいとき用のカスタムイベント登録
document.addEventListener("turbo:navigate", (e) => {
  const url = (e.detail && e.detail.url) ? e.detail.url : "#";
  const options = (e.detail && e.detail.options) ? e.detail.options : {};
  Turbo.visit(url, options);
});